"use strict";

import "./MultiSelector.css";
import React from "react";
import classnames from "classnames";
import lang from "./../../lang";
import Form from "./../Form";
import Checkbox from "./../Checkbox";
import MultiSelect from "./../MultiSelect";
import getModificationsByRef from "vfu/getModificationsByRef";

export default class MultiSelector extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = this.getDefaultState();
	}
	
	handleCheckboxChange(value) {
		this.setState({all: value}, () => this.handleChange());
	}
	
	handleSelectChange(value) {
		this.setState({value}, () => this.handleChange())
	}
	
	componentDidUpdate(prevProps) {
		if (this.state.all && getModificationsByRef(prevProps.options, this.props.options))
			this.handleChange();
	}
	
	handleChange() {
		this.props.onChange(
			this.state.all ?
				this.props.options.map(o=>o.value) :
				this.state.value,
			this.state.all
		);
	}
	
	clear() {
		if (this.refs.multiSelect) {
			this.refs.multiSelect.clear();
			this.setState({all: true});
		}
	}
	
	defaultIsAll() {
		if (this.props.defaultValue)
			return this.props.defaultValue.length === this.props.options.length;
		else
			return true;
	}
	
	getDefaultState() {
		return {
			all:	this.defaultIsAll(),
			value:	this.defaultIsAll() ? [] : this.props.defaultValue
		};
	}
	
	render() {
		
		const className = classnames("MultiSelector", this.props.className);
		
		return (
			<Form className={className}>
				<label>{this.props.title}</label>
				<div className="Container">
					<div className="All">
						<Checkbox checked={this.state.all} onChange={value => this.handleCheckboxChange(value)}/>
						<label>{lang.ALL}</label>
					</div>
					<MultiSelect
						ref="multiSelect"
						disabled={this.state.all && this.state.value.length > 0}
						options={this.props.options}
						defaultValue={this.state.value}
						onChange={value => this.handleSelectChange(value)}
						onClick={() => this.setState({all: false}, () => this.handleChange())}
						placeholder={`${lang._OR_SELECT_ONE_BY_ONE}`}
					/>
				</div>
			</Form>
		);
	}
	
}

MultiSelector.propTypes = {
	title: React.PropTypes.string,
	options: React.PropTypes.arrayOf(MultiSelect.Option),
	// ha nem adunk meg defaultValue-t, akkor
	// default az összeset adja
	defaultValue: React.PropTypes.arrayOf(React.PropTypes.string),
	onChange: React.PropTypes.func
};

MultiSelector.defaultProps = {
	title: "",
	options: [],
	onChange: (value, all) => {}
};


// WEBPACK FOOTER //
// ./~/vwa/components/MultiSelector/MultiSelector.jsx